import styled from 'styled-components';
import { getCurrencyDropdownItem } from './select.helpers';

export const SelectWrapper = styled.div`
  padding-left: 0;
  margin-left: 5;
  margin-bottom: 5px;
  cursor: pointer;
  position: relative;

  /* small device */
  @media (min-width: 320px) and (max-width: 991px) {
    margin-bottom: 5px;
  }
`;

export const Label = styled.div`
  color: var(--grey-95, #0C0D0D);
  font-size: 14px;
  font-family: "Montserrat Medium";
  margin-bottom: 8px;
`;


export const priceTypes = {
    ONE_EURO: 'currency-display-one-euro',
    TWO_EURO: 'currency-display-two-euro',
    THREE_EURO: 'currency-display-three-euro',
    FOUR_EURO: 'currency-display-four-euro',
    FIVE_EURO: 'currency-display-five-euro'
  }
  
  export const priceOptions = [
    {
      value: priceTypes.ONE_EURO,
      label: '€'
    },
    {
      value: priceTypes.TWO_EURO,
      label: '€€'
    },
    {
      value: priceTypes.THREE_EURO,
      label: '€€€'
    },
    {
      value: priceTypes.FOUR_EURO,
      label: '€€€€'
    },
    {
      value: priceTypes.FIVE_EURO,
      label: '€€€€€'
    }
  ];


export const CustomSingleValue = ({ children, ...props }) => {

  const selectedItem = props.getValue()[0];

  let customValue = getCurrencyDropdownItem({
    value: selectedItem?.value,
    label: selectedItem?.label,
    isSelected: false,
    isFocused: true
  }) || children;  

  return (
    <div style={{ color: '#333', padding: '2px 8px', background: '#f0f0f0', borderRadius: '4px' }} {...props.innerProps}>
      {customValue}
    </div>
  );
};


export const CustomMultiValue = ({ children, ...props }) => {

  return (
    <div style={{ display: 'flex', alignItems: 'center', background: '#f0f0f0', borderRadius: '4px', margin: '2px', padding: '2px 8px', height: 'auto', overflow: 'visible' }} {...props.innerProps}>
      <span>{children}</span>
      <span style={{ marginLeft: '8px', cursor: 'pointer' }} onClick={props.removeProps.onClick}>✕</span>
    </div>
  );
};


const CustomMenuItem = ({label, ...props}) => {

  return getCurrencyDropdownItem({
    label, ...props
  }) || label;
}

export const CustomOption = (props) => {
  return (
    <div styles = {{width: "100%"}}>
      <li {...props.innerProps} style = {{
         backgroundColor:  props.isSelected ? '#0095FF' : props.isFocused ? "#E6F4FF" : "transparent",
         color: props.isSelected ? "white" : "var(--grey-95, #0C0D0D)",
         cursor:"default",
         display:"block",
         fontSize:"inherit",
         padding:"8px 16px",
         width:"100%",
      }}>
        <div style ={{
          display:"flex",
          gap: '1px'
        }}>

        {CustomMenuItem({...props.data, isFocused: props.isFocused, isSelected: props.isSelected})}

        </div>
      </li>
    </div>
  );
};